import { useEffect, useState } from 'react';
import {
  Box,
  VStack,
  Text,
  Divider,
  FormControl,
  FormLabel,
  Input,
  Button,
  Spinner,
  useToast,
} from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useProfile, useUpdateProfile } from '../hooks/useProfile';

export function ProfileSection() {
  const { t } = useTranslation();
  const toast = useToast();
  const { data: user, isLoading } = useProfile();
  const update = useUpdateProfile();

  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [synced, setSynced] = useState(false);

  useEffect(() => {
    if (user && !synced) {
      setName(user.name ?? '');
      setPhone(user.phone ?? '');
      setSynced(true);
    }
  }, [user, synced]);

  const handleSave = () => {
    update.mutate(
      { name: name.trim(), phone: phone.trim() || null },
      {
        onSuccess: () => toast({ status: 'success', title: t('profile.saved'), duration: 2000 }),
        onError: () => toast({ status: 'error', title: t('common.error', 'Something went wrong') }),
      },
    );
  };

  return (
    <VStack align="stretch" spacing={3}>
      <Text fontSize="lg" fontWeight="bold" color="gray.800">
        {t('profile.title')}
      </Text>
      <Divider />
      {isLoading ? (
        <Spinner />
      ) : (
        <Box p={4} bg="gray.50" borderRadius="md">
          <VStack align="stretch" spacing={3}>
            <FormControl>
              <FormLabel>{t('profile.name')}</FormLabel>
              <Input bg="white" value={name} onChange={(e) => setName(e.target.value)} />
            </FormControl>
            <FormControl>
              <FormLabel>{t('profile.phone')}</FormLabel>
              <Input bg="white" value={phone} onChange={(e) => setPhone(e.target.value)} />
            </FormControl>
            <FormControl>
              <FormLabel>{t('profile.email')}</FormLabel>
              <Input value={user?.email ?? ''} isReadOnly bg="gray.100" />
            </FormControl>
            <Button colorScheme="brand" alignSelf="flex-start" onClick={handleSave} isLoading={update.isPending}>
              {t('common.save')}
            </Button>
          </VStack>
        </Box>
      )}
    </VStack>
  );
}

export default ProfileSection;
